import React from 'react';
import { connect } from 'react-redux';
import styles from './main.module.scss';
import mainImg from '../../assets/main.jpg';
import profile from '../../assets/profile.png';

const Main = ({words, link, navigateToSection}) => {
    const experienceYears = new Date().getFullYear() - 2018;
    const summary = words.aboutMeText.replace(/\n/g, ' ');
    const stack = ['React', 'TypeScript', 'Node.js', 'Next.js', 'React Native', 'Sass'];
    const highlights = [
        { value: `${experienceYears}+`, label: 'Years building products' },
        { value: 'Full stack', label: 'Frontend, backend, mobile' },
        { value: '5', label: 'Languages for international teams' }
    ];
    
    return(
        <section className={styles.container}>
            <div className={styles.heroBackground}>
                <img className={styles.mainImg} src={mainImg} alt="Workspace backdrop" />
            </div>
            <div className={styles.heroContent}>
                <div className={styles.copyColumn}>
                    <div className={styles.eyebrow}>Software Developer</div>
                    <h1 className={styles.name}>{words.name}</h1>
                    <div className={styles.profession}>{words.profession}</div>
                    <p className={styles.summary}>{summary}</p>
                    <div className={styles.actionRow}>
                        <a className={styles.primaryButton} target='_blank' href={link} rel="noreferrer">{words.downloadCV}</a>
                        <button type='button' className={styles.secondaryButton} onClick={() => navigateToSection('portfolio')}>
                            {words.portfolio}
                        </button>
                    </div>
                    <div className={styles.stack}>
                        {stack.map((item) => (
                            <span key={item} className={styles.stackItem}>{item}</span>
                        ))}
                    </div>
                </div>
                <div className={styles.profileCard}>
                    <div className={styles.profileFrame}>
                        <img className={styles.profileimg} src={profile} alt={words.name} />
                    </div>
                    <div className={styles.profileMeta}>Building polished web and mobile experiences with product thinking and strong delivery discipline.</div>
                    <div className={styles.highlights}>
                        {highlights.map((item) => (
                            <div key={item.label} className={styles.highlightCard}>
                                <div className={styles.highlightValue}>{item.value}</div>
                                <div className={styles.highlightLabel}>{item.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

const mapStateToProps = (state) => {
    return{
        words: state.main.words,
        link: state.main.link
    };
};

export default connect(mapStateToProps, {})(Main)